export default __webpack_public_path__ + "static/media/arrow_right.17add8f3.svg";